import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import setting from '../../config/setting'
import {KRIAlertChartDataFormationMonthly, KRIAlertChartDataFormationfloodingOverview} from '../SharedComponents/KRIAlertChartDataFormation'
import Button from '@material-ui/core/Button'
import {styles} from '../CSS/Styles';
import CustomizedChart from '../CSSComponent/chart'
import CustomizedTable from '../CSSComponent/table'
import PredictionDetail from './KRIDashboardComponent/KRIFloodingPredictionDetail'
import PredictionDetailtable from './KRIDashboardComponent/KRIFloodingPredictionDetailtable'
import DataSource from './KRIDashboardComponent/KRIRainfallReadingDetail'


class KRI extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value:0,
            filter: [],
            isFilterByThreshold: false,
            isFilterByRisk: false,
            show_detail: false,
            show_detail_date: '',
            show_data_source: false,
        }

    }

    setFilterBoolean() {
        let filter = false
        this.state.filter.Threshold.map((Threshold)=>{
            filter = filter || (this.state[Threshold] == true)
        })
        let FilterByCategory = filter

        filter = false
        this.state.filter.Risk.map((Risk)=>{
            filter = filter || (this.state[Risk] == true)
        })
        let FilterByRisk = filter

        this.setState({isFilterByThreshold: FilterByCategory})
        this.setState({isFilterByRisk: FilterByRisk})
    }

    componentWillMount() {
        this.getFilter()
    }


    handleChange = name => event => {
        this.setState({ [name]: event.target.checked })
    };

    componentDidUpdate(prevprops) {

    }

    getFilter() {
        let filterData = {
            'Threshold': ['Green', 'Amber', 'Red', 'Not Due'],
            'Risk': ['R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9']
        }
        this.setState( { filter: filterData } )
        for (let val in filterData) {
            let data = filterData[val]
            for (let filter in data) {
                this.setState({ [data[filter]]: true })
            }
        }
    }

    showfloodingdetail=(show)=>{
        console.log(show)
        this.setState({ show_detail: true })
        this.setState({ show_detail_date: show })
    };

    hidefloodingdetail=()=>{
        this.setState({show_detail:false})
    }

    showdatasource=()=>{
        this.setState({show_data_source:true})
    };

    hidedatasource=()=>{
        this.setState({show_data_source:false})
    }

    render() {
        const { classes } = this.props
        // console.log(this.props.alert)
        // console.log(this.props.data)

        // group the kri data
        let alert = KRIAlertChartDataFormationMonthly(this.props.data, this.props.alert, this.props.threshold)
        let flooding = KRIAlertChartDataFormationfloodingOverview(this.props.data, this.props.threshold)

        // console.log(flooding)
        // console.log(alert[0])
        const tableHeaderMap = {
            'Follow Up Action': 'follow_up_action',
            'Staff': 'assigned_user',
            'Date Identified': 'created_date',
            'Timeline': 'due_date'
        }
        const tableHeader = ['Ref', 'Follow Up Action', 'Staff', 'Date Identified', 'Timeline']
        const filters = ()=>{
            let filterJSX = []
            for (var filter in this.state.filter) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <typography style={{ display: 'inline-block', minWidth: '120px'}}> {filter} : </typography>
                        {this.state.filter[filter].map((data)=>{
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data]}
                                        onChange={this.handleChange(data)}
                                        value={data}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
        const filterheader = filters();
        if (this.props.data == null) {
            return (<div/>)
        }

        return (
            <div flexGrow={1}>
                {filterheader}
                {this.state["R1"] && <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Card className={classes.cardL1} style={{ position: 'relative' }}>
                                <CardContent className={classes.content_compact}>
                                    {
                                        this.state.show_detail &&
                                        <PredictionDetail back={this.hidefloodingdetail} data={this.props.data} date={this.state.show_detail_date} threshold={this.props.threshold} />
                                    }

                                    {
                                        this.state.show_data_source &&
                                        <DataSource back={this.hidedatasource} threshold={this.props.threshold} />
                                    }

                                    {
                                        (!this.state.show_detail && !this.state.show_data_source) &&
                                        <CustomizedChart eEvent={this.showfloodingdetail} data={flooding} title={[flooding.risk_name, flooding.kri_id + ' -- ' + flooding.description]} />
                                    }

                                    {
                                        (!this.state.show_detail && !this.state.show_data_source) &&
                                        <Button variant='outlined' color='primary' className={classes.button} style={{ position: 'absolute', top: '0px', right: '0px' }} onClick={() => { this.showdatasource() }}
                                        >
                                            Data Source
                                        </Button>
                                    }
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card className={classes.cardL1}>
                            {
                                this.state.show_detail &&
                                <PredictionDetailtable back={this.hidefloodingdetail} data={this.props.data} date={this.state.show_detail_date} threshold={this.props.threshold} />
                            }

                            {
                                this.state.show_data_source &&
                                <div />
                            }

                            {
                                (!this.state.show_detail && !this.state.show_data_source) &&
                                <CustomizedTable
                                    preTableText= 'Rationale: Undefined. Please specify rationales and Actions under KRI Monitoring--KRI Alert'
                                    tableHeader = {tableHeader}
                                />
                            }
                            </Card>
                        </Grid>
                    </Grid>
                }
                {alert.sort((a, b)=>(a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
                    .map((alert)=> {
                        //console.log(alert.alert_tasks)
                        if (!this.state[(alert.risk_name).substring(0,2)]) {
                            return (null)
                        }

                        let lastBarColor = (alert.data.datasets)[0].backgroundColor[7]
                        if (!this.state.Green && lastBarColor === setting.COLOR.GREEN) {
                            return (null)
                        }

                        if (!this.state.Amber && lastBarColor === setting.COLOR.AMBER) {
                            return (null)
                        }
                        if (!this.state.Red  && lastBarColor === setting.COLOR.RED) {
                            return (null)
                        }

                        return (
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <Card className={classes.cardL1}>
                                        <CardContent className={classes.content_compact}>
                                            <CustomizedChart data={alert.data} title={[alert.data.risk_name, alert.data.kri_id + ' -- ' + alert.data.description]}/>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card className={classes.cardL1}>
                                        <CustomizedTable
                                            preTableText={
                                                (alert.alert_tasks)[0] == null ?
                                                    'Rationale: Undefined. Please specify rationales and Actions under \'KRI Monitoring\'--\'KRI Alert\''
                                                    : 'Rationale: '+(alert.alert_tasks)[0].rationales
                                            }
                                            tableHeader = {tableHeader}
                                            data = {alert.alert_tasks == null ? null : alert.alert_tasks}
                                            tableHeaderMap = {tableHeaderMap}
                                        />
                                    </Card>
                                </Grid>
                            </Grid>
                        )
                    })}
            </div>
        )
    }
}
export default withStyles(styles)(KRI)


// WEBPACK FOOTER //
// ./src/components/Dashboard/ERMKRIDashboard.js